var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.datosSesion.idPerfil===6)?_c('div',[_c('MenuDocente')],1):(_vm.datosSesion.idPerfil===7)?_c('div',[_c('MenuEstudiante')],1):_c('div',[_c('MenuPrincipal')],1),_c('router-view'),_c('PiePagina')],1)}
var staticRenderFns = []

export { render, staticRenderFns }